import ApplicationRecord from './ApplicationRecord';
import { registerModel } from './modelRegistry';
import { getUserClass } from './User';
import { getMediaClass } from './Media';

type ModelsList = Array<typeof ApplicationRecord>;

let registered = false;
const registeredModels: Hash<boolean> = {};

export function registerModels(otherModels?: ModelsList) {
  if (registered) {
    return registeredModels;
  }
  const models: ModelsList = [getUserClass(), getMediaClass()];
  if (otherModels) {
    models.push(...otherModels);
  }

  models.forEach(klass => registerModel(klass));

  // 👇 Register models with Spraypaint
  //
  // Spraypaint requires at least a single use of a model so it is registered
  // for use when resolving relationships.
  models.forEach(Klass => {
    const key = Klass.jsonapiType;
    const result = new Klass() && true;
    if (key) {
      registeredModels[key] = result;
    }
  });
  registered = true;
  return registeredModels;
}

export default registeredModels;
